import { useTheme } from '@heathmont/moon-themes';
import Points from '~/client/features/Tournaments/modules/TournamentDetails/shared/Leaderboard/LeaderboardList/LeaderboardItem/Points';
import Position from '~/client/features/Tournaments/modules/TournamentDetails/shared/Leaderboard/LeaderboardList/LeaderboardItem/Position';
import Username from '~/client/features/Tournaments/modules/TournamentDetails/shared/Leaderboard/LeaderboardList/LeaderboardItem/Username';
import Container from './Container';

type Props = {
  position?: number;
  isMyScore?: boolean;
  username?: string;
  points?: string;
};

const LeaderboardItem: FC<Props> = ({
  username,
  isMyScore,
  points,
  position,
}) => {
  const theme = useTheme();
  return (
    <Container isMyScore={isMyScore}>
      <Position size="Small" position={position} isMyScore={isMyScore} />
      <Username
        position={position}
        username={username}
        color={theme.color.bulma[100]}
        isMyScore={isMyScore}
      />
      <Points position={position} points={points} center={false} />
    </Container>
  );
};

export default LeaderboardItem;
